import { createSlice } from '@reduxjs/toolkit'
import { resetAllReduxStates } from './resetAllReduxStatesAction'

const initialState = {
  project: null,
}

// Carries the row a PM clicked in the Project Delivery list ("My Projects")
// forward into the Delivery Progress / Estimation History pages, so
// ProjectSummaryBanner can render Project Name/Zoho ID/CSM/Status without a
// second network call -- there is no /pm/projects/:id endpoint to fetch it
// from (PM_FLOW_FRONTEND_API_GUIDE, section 2).
const pmSelectedProjectSlice = createSlice({
  name: 'pmSelectedProject',
  initialState,
  reducers: {
    setPMSelectedProject: (state, action) => {
      state.project = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetAllReduxStates, () => initialState)
  },
})

export const { setPMSelectedProject } = pmSelectedProjectSlice.actions
export const pmSelectedProjectSelector = (state) =>
  state.pmSelectedProject.project
export default pmSelectedProjectSlice.reducer
